<ng-container *ngIf="vehicle as v; else empty">
  <!-- Cabecera del vehículo -->
  <div class="flex items-center gap-3 mb-4">
    <img class="h-12 w-16 object-contain rounded-lg bg-slate-100 dark:bg-white/5" [src]="v.icon" alt="vehículo" />
    <div>
      <div class="font-bold text-[#0e1726] dark:text-white">{{ v.brand }} {{ v.vehicle_model }}</div>
      <div class="text-xs text-gray-500 dark:text-white/60">Placa {{ v.plate }} · {{ v.driver.name }}</div>
    </div>
  </div>

  <!-- Stat cards -->
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-3">
      <div class="text-xs text-gray-500 dark:text-white/60">Eficiencia</div>
      <div class="text-xl font-bold text-emerald-500">{{ v.analytics.fuelEfficiencyKmpl }}</div>
      <div class="text-[11px] text-gray-400">km/gal</div>
    </div>
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-3">
      <div class="text-xs text-gray-500 dark:text-white/60">Ralentí</div>
      <div class="text-xl font-bold text-amber-500">{{ v.analytics.idleTimeHours }}</div>
      <div class="text-[11px] text-gray-400">horas</div>
    </div>
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-3">
      <div class="text-xs text-gray-500 dark:text-white/60">Costo / Km</div>
      <div class="text-xl font-bold text-[#0e1726] dark:text-white">${{ v.analytics.costPerKm | number: '1.0-0' }}</div>
      <div class="text-[11px] text-gray-400">COP</div>
    </div>
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-3">
      <div class="text-xs text-gray-500 dark:text-white/60">Distancia mes</div>
      <div class="text-xl font-bold text-[#0e1726] dark:text-white">{{ v.analytics.distanceMonthKm | number: '1.0-0' }}</div>
      <div class="text-[11px] text-gray-400">km</div>
    </div>
  </div>

  <!-- Gauge + Radar -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-4">
      <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Puntaje del conductor</div>
      <apx-chart
        *ngIf="gauge"
        [series]="gauge.series"
        [chart]="gauge.chart"
        [colors]="gauge.colors"
        [plotOptions]="gauge.plotOptions"
        [fill]="gauge.fill"
        [stroke]="gauge.stroke"
        [labels]="gauge.labels"
      ></apx-chart>
    </div>

    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-4">
      <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Comportamiento de conducción</div>
      <apx-chart
        *ngIf="radar"
        [series]="radar.series"
        [chart]="radar.chart"
        [colors]="radar.colors"
        [xaxis]="radar.xaxis"
        [yaxis]="radar.yaxis"
        [fill]="radar.fill"
        [stroke]="radar.stroke"
        [markers]="radar.markers"
        [plotOptions]="radar.plotOptions"
        [tooltip]="radar.tooltip"
      ></apx-chart>
    </div>
  </div>

  <!-- Tendencias -->
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-4">
      <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Evolución del puntaje</div>
      <div class="text-xs text-gray-400 mb-2">Últimos 12 meses</div>
      <apx-chart
        *ngIf="scoreTrend"
        [series]="scoreTrend.series"
        [chart]="scoreTrend.chart"
        [colors]="scoreTrend.colors"
        [dataLabels]="scoreTrend.dataLabels"
        [stroke]="scoreTrend.stroke"
        [markers]="scoreTrend.markers"
        [xaxis]="scoreTrend.xaxis"
        [yaxis]="scoreTrend.yaxis"
        [grid]="scoreTrend.grid"
        [tooltip]="scoreTrend.tooltip"
      ></apx-chart>
    </div>

    <div class="rounded-xl border border-gray-100 dark:border-white/10 p-4">
      <div class="font-semibold text-[#0e1726] dark:text-white mb-1">Costo de combustible mensual</div>
      <div class="text-xs text-gray-400 mb-2">COP · últimos 12 meses</div>
      <apx-chart
        *ngIf="fuelBars"
        [series]="fuelBars.series"
        [chart]="fuelBars.chart"
        [colors]="fuelBars.colors"
        [dataLabels]="fuelBars.dataLabels"
        [plotOptions]="fuelBars.plotOptions"
        [xaxis]="fuelBars.xaxis"
        [yaxis]="fuelBars.yaxis"
        [grid]="fuelBars.grid"
        [tooltip]="fuelBars.tooltip"
      ></apx-chart>
    </div>
  </div>
</ng-container>

<ng-template #empty>
  <div class="flex flex-col items-center justify-center text-center py-12 text-gray-400">
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><path d="M12 8v4M12 16h.01"/></svg>
    <p class="mt-2 text-sm">Selecciona un vehículo para ver sus analíticas.</p>
  </div>
</ng-template>
